import axios from 'axios';
import { isHTTPError } from 'ky';

type ApiErrorPayload = {
  message?: string;
  err_message?: string;
};

function normalizeApiErrorPayload(data: unknown): ApiErrorPayload | undefined {
  if (Array.isArray(data)) {
    const first = data[0];

    return typeof first === 'object' && first !== null ? (first as ApiErrorPayload) : undefined;
  }

  if (typeof data === 'object' && data !== null) {
    return data as ApiErrorPayload;
  }

  return undefined;
}

function getApiErrorPayload(error: unknown): ApiErrorPayload | undefined {
  if (isHTTPError(error)) {
    return normalizeApiErrorPayload(error.data);
  }

  if (axios.isAxiosError(error)) {
    return normalizeApiErrorPayload(error.response?.data);
  }

  return undefined;
}

export function getApiErrorMessage(error: unknown, fallbackMessage?: string): string | undefined {
  const payload = getApiErrorPayload(error);

  return payload?.message ?? payload?.err_message ?? fallbackMessage;
}
